import InstagramFeed from './InstagramFeed'

export default InstagramFeed
